import { createFileRoute } from "@tanstack/react-router";

import Login from "@/features/auth/Login";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/login")({
  component: () => (
    <BasicLayout>
      <Login />
    </BasicLayout>
  ),
});
